


let recipeTagBox = document.querySelector('[data-alvine-role="recipeTagBox"]');

if (recipeTagBox) {
    let recipeTags = document.querySelectorAll('[data-alvine-role="recipeTags"]')
    if (recipeTags.length === 0) {
        /**
         * Ausblenden der Kategorie-Box, wenn keine Tags vorhanden sind
         */
        recipeTagBox.parentElement.style.display = "none";

    }

    let tags = [];
    let elementMap = {};
    recipeTags.forEach(function (script) {
        let json = script.innerHTML;
        let element = script.parentElement;
        if (json) {
            let JSONData = JSON.parse(script.innerHTML);
            JSONData.forEach(function (tag) {
                let name = tag.name.trim();
                if (tags.includes(name) === false) {
                    tags.push(name);
                    if (elementMap[name] === undefined) {
                        elementMap[name] = [];
                    }
                    elementMap[name].push(element);
                }

            });
        }

    });
    if (tags.length > 0) {
        tags.forEach(function (tag) {
            let link = document.createElement('a');
            link.innerHTML = tag.trim();
            link.setAttribute('data-alvine-role', 'recipeTagButton');
            link.setAttribute('data-alvine-value', tag.trim());
            link.classList.add('uk-button');
            link.classList.add('uk-button-tertiary');
            link.classList.add('rounded');

            link.addEventListener('click', function () {
                this.classList.toggle('active');

                if (this.classList.contains("active")) {
                    this.classList.add('uk-button-secondary');
                    this.classList.remove('uk-button-tertiary');
                } else {
                    this.classList.remove('uk-button-secondary');
                    this.classList.add('uk-button-tertiary');
                }

                filterRecipe(elementMap);

            });
            recipeTagBox.appendChild(link);
        });
    }
    /**
     * Filter über die URL
     */
    if(location.hash!==''){
        let hash = location.hash.replace("#", "");
        let button = document.querySelector('[data-alvine-role="recipeTagButton"][data-alvine-value="' + decodeURI(hash) + '"]');
        if(button){
            button.click();
        }
    
    }

}


function filterRecipe(elementMap) {

    let active = document.querySelectorAll('[data-alvine-role="recipeTagButton"].active');

    if (active.length === 0) {
        /**
        * alle einblenden
        */
        for (const [key, value] of Object.entries(elementMap)) {
            elementMap[key].forEach(function (element) {
                element.style.display = "block";
            });
        }
        return;
    }

    /**
     * alle ausblenden
     */
    for (const [key, value] of Object.entries(elementMap)) {
        elementMap[key].forEach(function (element) {
            element.style.display = "none";
        });
    }

    /**
     * aktive einblenden
     */
    active.forEach(function (button) {
        let name = button.innerText;
        elementMap[name].forEach(function (element) {
            element.style.display = "block";
        });
    });
}